import {
	ADD_RX_TRANSFER_REQUEST_REQUEST,
	ADD_RX_TRANSFER_REQUEST_SUCCESS,
	ADD_RX_TRANSFER_REQUEST_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const RxTransferFormReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_RX_TRANSFER_REQUEST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case ADD_RX_TRANSFER_REQUEST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case ADD_RX_TRANSFER_REQUEST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default RxTransferFormReducer